/* TAQI FOR OUD & PERFUMES — SHOPIFY CART + MODAL */
var C={keys:[],data:{items:[],item_count:0,total_price:0}};
var WA='97477795019';

/* ── CART OPEN/CLOSE ── */
function openCart(){
  fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(d){
    C.data=d;C.keys=d.items.map(function(i){return i.key;});
    badge(d.item_count);draw(d);
  });
  document.getElementById('cartOverlay').classList.add('open');
  document.getElementById('cartDrawer').classList.add('open');
  document.body.style.overflow='hidden';
}
function closeCart(){
  document.getElementById('cartOverlay').classList.remove('open');
  document.getElementById('cartDrawer').classList.remove('open');
  document.body.style.overflow='';
}

/* ── BADGE ── */
function badge(n){
  var el=document.getElementById('cartBadge');
  if(!el)return;
  el.textContent=n;
  el.classList.toggle('on',n>0);
}

/* ── ADD TO CART ── */
function addItem(variantId,title,btn){
  if(btn){btn.textContent='...';btn.disabled=true;}
  fetch('/cart/add.js',{
    method:'POST',credentials:'same-origin',
    headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
    body:JSON.stringify({id:parseInt(variantId),quantity:1})
  })
  .then(function(r){if(!r.ok)throw r.status;return r.json();})
  .then(function(item){
    if(btn){btn.textContent='Add to Cart';btn.disabled=false;}
    showNotif((title||item.title)+' '+t('cart.added'));
    fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(d){
      C.data=d;C.keys=d.items.map(function(i){return i.key;});badge(d.item_count);draw(d);
    });
    openCart();
  })
  .catch(function(e){
    console.error('addItem failed:',e);
    if(btn){btn.textContent='Add to Cart';btn.disabled=false;}
    showNotif(t('cart.fail'));
  });
}

/* ── DRAW DRAWER ── */
function draw(d){
  var body=document.getElementById('cartBody');
  var foot=document.getElementById('cartFoot');
  if(!body)return;
  if(!d||d.item_count===0){
    body.innerHTML='<div class="cart-empty-msg"><span>&#128717;</span><p>'+t('cart.empty')+'</p></div>';
    if(foot)foot.style.display='none';
    return;
  }
  if(foot)foot.style.display='block';
  C.keys=d.items.map(function(i){return i.key;});
  body.innerHTML=d.items.map(function(item,idx){
    var img=item.image?'<img src="'+item.image+'" alt="">':'<div class="ci-no-img">&#127869;</div>';
    var vt=(item.variant_title&&item.variant_title!=='Default Title')?'<div class="ci-meta">'+item.variant_title+'</div>':'';
    return'<div class="ci">'+img+'<div class="ci-info"><div class="ci-name">'+item.product_title+'</div>'+vt+'<div class="ci-price">'+(item.price/100).toFixed(0)+' '+t('unit.qar')+'</div><div class="ci-qty"><button class="qbtn" data-i="'+idx+'" data-d="-1" onclick="chQty(this)">&#8722;</button><span style="font-size:0.82rem;min-width:20px;text-align:center">'+item.quantity+'</span><button class="qbtn" data-i="'+idx+'" data-d="1" onclick="chQty(this)">+</button></div><button class="ci-remove" data-i="'+idx+'" onclick="rmItem(this)">'+t('cart.remove')+'</button></div></div>';
  }).join('');
  var tot=document.getElementById('cartTotalVal');
  if(tot)tot.textContent=(d.total_price/100).toFixed(0)+' '+t('unit.qar');
}

/* ── QTY / REMOVE ── */
function chQty(btn){
  var idx=parseInt(btn.dataset.i),d=parseInt(btn.dataset.d);
  var key=C.keys[idx],cur=C.data.items[idx]?C.data.items[idx].quantity:1;
  fetch('/cart/change.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:Math.max(0,cur+d)})})
    .then(function(r){return r.json();}).then(function(c){C.data=c;C.keys=c.items.map(function(i){return i.key;});badge(c.item_count);draw(c);});
}
function rmItem(btn){
  var key=C.keys[parseInt(btn.dataset.i)];
  fetch('/cart/change.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:0})})
    .then(function(r){return r.json();}).then(function(c){C.data=c;C.keys=c.items.map(function(i){return i.key;});badge(c.item_count);draw(c);});
}

/* ── WHATSAPP ORDER ── */
function waOrder(){
  fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(d){
    if(!d||d.item_count===0)return;
    var lines=d.items.map(function(i){return encodeURIComponent(i.product_title)+' x'+i.quantity+' - '+(i.line_price/100).toFixed(0)+' '+t('unit.qar');}).join('%0A');
    var total=(d.total_price/100).toFixed(0);
    window.open('https://wa.me/'+WA+'?text=New Order:%0A'+lines+'%0ATotal: '+total+' '+t('unit.qar'),'_blank');
  });
}

/* ── QUICK VIEW ── */
var QV={vid:null,title:''};
function openQV(name,imgUrl,ptype,price,variantId,productUrl,wa){
  QV.vid=variantId;QV.title=name;
  var i=document.getElementById('qvImg');
  if(i){i.src=imgUrl||'';i.style.display=imgUrl?'block':'none';}
  var n=document.getElementById('qvName');if(n)n.textContent=name;
  var ty=document.getElementById('qvType');if(ty)ty.textContent=ptype;
  var p=document.getElementById('qvPrice');if(p)p.textContent=price+' '+t('unit.qar');
  var vb=document.getElementById('qvView');if(vb)vb.href=productUrl;
  qvZoomReset();
  var ov=document.getElementById('qvOverlay');
  if(ov){ov.classList.add('active');document.body.style.overflow='hidden';}
}
function closeQV(){
  qvZoomReset();
  var ov=document.getElementById('qvOverlay');
  if(ov){ov.classList.remove('active');document.body.style.overflow='';}
}
/* ── IMAGE ZOOM (buttons + wheel + pinch + bounded drag-pan) inside the product window ── */
var QZ={scale:1,x:0,y:0};
var QZP={};                                   /* active pointers by id */
var QD={down:false,sx:0,sy:0,ox:0,oy:0,pd:0,ps:1};
function qvClamp(){
  var w=document.getElementById('qvImgWrap'); if(!w)return;
  if(QZ.scale<=1){QZ.x=0;QZ.y=0;return;}
  var r=w.getBoundingClientRect();
  var mx=(QZ.scale-1)*r.width/2, my=(QZ.scale-1)*r.height/2;
  QZ.x=Math.max(-mx,Math.min(mx,QZ.x));
  QZ.y=Math.max(-my,Math.min(my,QZ.y));
}
function qvApply(){
  var i=document.getElementById('qvImg'),w=document.getElementById('qvImgWrap');
  if(!i)return;
  qvClamp();
  i.style.transform='translate('+QZ.x+'px,'+QZ.y+'px) scale('+QZ.scale+')';
  if(w)w.classList.toggle('zoomed',QZ.scale>1);
}
function qvSetScale(s){
  QZ.scale=Math.max(1,Math.min(4,Math.round(s*100)/100));
  if(QZ.scale===1){QZ.x=0;QZ.y=0;}
  qvApply();
}
function qvZoom(dir){ qvSetScale(QZ.scale+dir*0.5); }
function qvZoomReset(){ QZ.scale=1;QZ.x=0;QZ.y=0;QZP={};QD.down=false; var w=document.getElementById('qvImgWrap'); if(w)w.classList.remove('panning'); qvApply(); }
function qvPDist(){ var k=Object.keys(QZP); if(k.length<2)return 0; var a=QZP[k[0]],b=QZP[k[1]]; return Math.hypot(a.x-b.x,a.y-b.y); }
document.addEventListener('DOMContentLoaded',function(){
  var w=document.getElementById('qvImgWrap');
  if(!w)return;
  w.addEventListener('pointerdown',function(e){
    try{w.setPointerCapture(e.pointerId);}catch(_){}
    QZP[e.pointerId]={x:e.clientX,y:e.clientY};
    var k=Object.keys(QZP);
    if(k.length===1){ QD.down=true;QD.sx=e.clientX;QD.sy=e.clientY;QD.ox=QZ.x;QD.oy=QZ.y; if(QZ.scale>1)w.classList.add('panning'); }
    else if(k.length>=2){ QD.down=false;QD.pd=qvPDist();QD.ps=QZ.scale; w.classList.add('panning'); }
  });
  w.addEventListener('pointermove',function(e){
    if(!QZP[e.pointerId])return;
    QZP[e.pointerId]={x:e.clientX,y:e.clientY};
    var k=Object.keys(QZP);
    if(k.length>=2){ if(QD.pd>0)qvSetScale(QD.ps*(qvPDist()/QD.pd)); }
    else if(QD.down && QZ.scale>1){ QZ.x=QD.ox+(e.clientX-QD.sx);QZ.y=QD.oy+(e.clientY-QD.sy); qvApply(); }
  });
  function up(e){
    delete QZP[e.pointerId];
    var k=Object.keys(QZP);
    if(k.length<2)QD.pd=0;
    if(k.length===0){QD.down=false;w.classList.remove('panning');}
    else if(k.length===1){ var id=k[0]; QD.down=true;QD.sx=QZP[id].x;QD.sy=QZP[id].y;QD.ox=QZ.x;QD.oy=QZ.y; }
  }
  w.addEventListener('pointerup',up);
  w.addEventListener('pointercancel',up);
  w.addEventListener('wheel',function(e){ e.preventDefault(); qvSetScale(QZ.scale+(e.deltaY<0?0.3:-0.3)); },{passive:false});
  w.addEventListener('dblclick',function(e){ e.preventDefault(); qvSetScale(QZ.scale>1?1:2.5); });
});
function qvAdd(){
  if(!QV.vid)return;
  var btn=document.getElementById('qvAddBtn');
  if(btn){btn.textContent='Adding...';btn.disabled=true;}
  fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({id:parseInt(QV.vid),quantity:1})})
    .then(function(r){return r.json();})
    .then(function(item){
      fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(d){
        C.data=d;C.keys=d.items.map(function(i){return i.key;});badge(d.item_count);draw(d);
      });
      closeQV();openCart();
      showNotif(QV.title+' '+t('cart.added'));
      if(btn){btn.textContent='Add to Cart';btn.disabled=false;}
    })
    .catch(function(){if(btn){btn.textContent='Add to Cart';btn.disabled=false;}});
}

/* ── NOTIFICATION ── */
function showNotif(msg){
  var n=document.getElementById('siteNotif');
  if(!n)return;
  n.textContent=msg;n.classList.add('show');
  setTimeout(function(){n.classList.remove('show');},2500);
}

/* ── INIT ── */
document.addEventListener('DOMContentLoaded',function(){
  fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(d){badge(d.item_count);});
  var obs=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting)e.target.classList.add('visible');});},{threshold:0.1});
  document.querySelectorAll('.fade-in').forEach(function(el){obs.observe(el);});
});

/* ── SPLASH INTRO + SCROLL-TO-TOP ── */
(function(){
  function hideSplash(){
    var s=document.getElementById('splash');
    if(s && !s.classList.contains('hide')){ s.classList.add('hide'); setTimeout(function(){ if(s&&s.parentNode)s.parentNode.removeChild(s); },800); }
  }
  window.addEventListener('load',function(){ setTimeout(hideSplash,2100); });
  setTimeout(hideSplash,4200);
  document.addEventListener('DOMContentLoaded',function(){
    var s=document.getElementById('splash'); if(s)s.addEventListener('click',hideSplash);
    var st=document.getElementById('scrollTop');
    if(st){ window.addEventListener('scroll',function(){ if(window.scrollY>420)st.classList.add('show'); else st.classList.remove('show'); },{passive:true}); }
  });
})();

/* ── MOBILE MENU ── */
function toggleMenu(){ var m=document.getElementById('mobileMenu'); if(m) m.classList.toggle('open'); }
function closeMenu(){ var m=document.getElementById('mobileMenu'); if(m) m.classList.remove('open'); }
window.addEventListener('resize',function(){ if(window.innerWidth>920) closeMenu(); });
